module.exports = __webpack_public_path__ + "img/badge-box.f2f33ba7.svg";